module.exports = __webpack_public_path__ + "img/login-logo.5ec9ce0f.png";